export function fileIsDealerOnly({ userGroupId } = {}) {
  return userGroupId === 6
}
